var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M26.1,16.4v-6.2c0.1-0.9-0.4-1.7-1.1-2.2c-0.8-0.4-1.7-0.4-2.5,0.1l-9.9,5.6H6.6c-1.9,0.1-3.5,1.7-3.5,3.6 v10.5c0,1.9,1.6,3.5,3.5,3.5h5.9l9.9,5.7c0.4,0.2,0.9,0.3,1.4,0.4c0.4,0,0.8-0.1,1.1-0.3c0.7-0.5,1.2-1.3,1.1-2.2v-6.3 c3-0.4,5.3-3,5.3-6.1C31.3,19.4,29.1,16.8,26.1,16.4z M9.4,29.6v-7.1c0-0.5-0.4-0.9-0.9-0.9S7.6,22,7.6,22.4v7.1H6.6 c-1-0.1-1.7-0.8-1.7-1.8V17.3c0-1,0.7-1.7,1.7-1.8h5.3v14.1H9.4z M24.2,34.8c0,0.3,0,0.5-0.2,0.7c-0.2,0-0.5-0.1-0.7-0.2l-9.6-5.4 V15.1l6.1-3.5v13.6c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9V10.6l1.7-0.9c0.3-0.3,0.6-0.3,0.7-0.2c0.2,0.2,0.2,0.4,0.2,0.7 V34.8z M26.1,26.9v-8.7c2,0.4,3.5,2.2,3.5,4.3C29.6,24.6,28.1,26.4,26.1,26.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M35.6,9.4C35.5,9.3,35.5,9.3,35.6,9.4c-0.5-0.3-1-0.2-1.3,0.2c0,0-0.1,0.1-0.1,0.1 c-0.2,0.4-0.1,0.9,0.3,1.1c3.6,2.8,5.7,7.1,5.7,11.7c0,4.6-2.1,8.9-5.7,11.8c0,0-0.1,0-0.1,0.1c-0.3,0.3-0.4,0.8-0.1,1.1 c0.2,0.2,0.4,0.4,0.7,0.4l0.6-0.2c4-3.2,6.3-8.1,6.3-13.2C41.9,17.4,39.5,12.5,35.6,9.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M36.7,22.4c0-3.7-1.9-7.2-5-9.3c-0.1-0.1-0.3-0.3-0.4-0.3c-0.5-0.2-1,0.1-1.1,0.6c-0.2,0.5,0.1,1,0.6,1.1 c1,0.7,1.9,1.6,2.6,2.6c3,4.4,1.8,10.4-2.6,13.3c0,0-0.1,0-0.1,0.1c-0.3,0.3-0.4,0.8-0.1,1.1c0.2,0.2,0.4,0.4,0.7,0.4l0.5-0.2 C34.8,29.7,36.6,26.2,36.7,22.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M24.2,10.1c0-0.3,0-0.5-0.2-0.7c-0.1-0.1-0.4-0.1-0.7,0.2l-1.7,0.9v14.6c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9V11.6l-6.1,3.5v14.9l9.6,5.4c0.2,0.1,0.5,0.2,0.7,0.2c0.2-0.2,0.2-0.4,0.2-0.7V10.1z M19.9,29.6 C19.9,29.6,19.9,29.6,19.9,29.6v-1.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v1.8c0,0.5-0.4,0.9-0.9,0.9 C20.3,30.5,19.9,30,19.9,29.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M11.9,15.4H6.6c-1,0.1-1.7,0.8-1.7,1.8v10.5c0,1,0.7,1.7,1.7,1.8h0.9v-7.1c0-0.5,0.4-0.9,0.9-0.9 s0.9,0.4,0.9,0.9v7.1h2.6V15.4z M8.4,20.8c-0.5,0-0.9-0.4-0.9-0.9v-1.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v1.8 C9.4,20.3,8.9,20.8,8.4,20.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M21.6,29.6v-1.8c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v1.8c0,0,0,0,0,0c0,0.5,0.4,0.9,0.9,0.9 C21.2,30.5,21.7,30,21.6,29.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M9.4,18.1c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v1.8c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V18.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M26.1,18.1v8.7c2.1-0.5,3.5-2.3,3.5-4.4C29.5,20.4,28.1,18.6,26.1,18.1z"
}));

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.738c8717a244fbf5cc5481f71e941e86.svg";
export { ForwardRef as ReactComponent };